import { useCallback, useMemo } from 'react'

import { useAppDataContext } from '@cox/core-ui8/dist/AppDataContext'
import { AlignmentProps, Button } from '@cox/core-ui8/dist/Button'
import axios from 'axios'

import { ReactButtonProps } from './types'
import { WEB_APIS } from '../../constants'
import withAEM from '../../hoc/withAEM'
import { useInversionData } from '../../hooks/useInversionData'
import { getInversionTokenValues } from '../../utils/inversion-util'
import { getImageSrc } from '../../utils/local-util'
import { getTokenValues } from '../../utils/rule-builder-util'

const ReactButton = (props: ReactButtonProps): JSX.Element => {
  const {
    text = '',
    icon,
    iconAltText,
    iconPosition,
    tokenProperties,
    anchor,
    linkUrl,
    linkId,
    linkType,
    tokenId = '',
    tokenUrl = '',
    alignment,
    index,
    hideMCP = false,
    isInEditor = false,
    setDisposition = false,
    offerId = '',
    dispositionList = '',
    isParsed = false
  } = props

  // Inversion Changes
  const inversionItems = useInversionData()
  const newItems = useMemo(() => inversionItems, [inversionItems])
  const { appData } = useAppDataContext()
  const isLocal = appData?.page?.isLocal
  const invTokenregex = /\[\[(?!token|offer)[^\]]+\]\]/g

  const inversionText = getInversionTokenValues(text, newItems)
  const inversionURL = getInversionTokenValues(tokenUrl, newItems)
  const inversionId = getInversionTokenValues(tokenId, newItems)

  const getText = () => {
    return isLocal === 'true' && invTokenregex.test(text) ? inversionText : text
  }

  const getLinkId = () => {
    return isLocal === 'true' && invTokenregex.test(tokenId) ? inversionId : linkId
  }

  const tokenText = isParsed ? text : (getTokenValues(getText(), tokenProperties) as string)
  const tokenIcon = isParsed ? icon : (getTokenValues(icon, tokenProperties) as string)
  const iconSrc = getImageSrc(tokenIcon)
  const tokenAnchor = isParsed ? getLinkId() || anchor : (getTokenValues(getLinkId() || anchor, tokenProperties) as string)
  const tokenButtonUrl = isParsed ? linkUrl : linkUrl && (getTokenValues(linkUrl, tokenProperties) as string)
  const tokenLinkType = isParsed ? linkType : (getTokenValues(linkType, tokenProperties) as string)
  const tokenAlignment = isParsed
    ? alignment
    : (getTokenValues(alignment, tokenProperties) as string) || AlignmentProps.CENTER
  const ButtonWithAEM = withAEM(Button)

  // Checks if hideMCP flag is true and that display is in dispatcher, not in author:
  const mcpClass = hideMCP && isInEditor == false ? 'd-none' : ''

  // Set Disposition Logic for Pinpoint Offers
  let setDispositionProps = {}
  if (setDisposition && !isInEditor) {
    const dispList = dispositionList.length > 0 && !dispositionList.startsWith('[[offer.') && JSON.parse(dispositionList)

    {
      dispList &&
        dispList?.map((dispListItems: any) => {
          dispListItems.Type = 'ACCEPTED'
          dispListItems.DateTime = 'date_time'
        })
    }

    const handleAddToCart = useCallback((dispositionList: any) => {
      try {
        const parsedDispositionList: any =
          decodeURIComponent(dispositionList) && JSON.parse(decodeURIComponent(dispositionList))
        const dispositionPayload = { DispositionList: parsedDispositionList?.DispositionList }
        axios.post(WEB_APIS.SET_DISPOSITION, dispositionPayload, {
          withCredentials: true
        })
      } catch (err) {
        console.error(err)
      }
    }, [])

    setDispositionProps = {
      customProps: {
        setDisposition: setDisposition,
        offerId: offerId,
        onAddToCart: handleAddToCart,
        dispositionList: encodeURIComponent(
          JSON.stringify({
            DispositionList: dispList
          })
        )
      }
    }
  }

  const getButtonURL = () => {
    return isLocal === 'true' && invTokenregex.test(tokenUrl) ? inversionURL : tokenButtonUrl
  }

  return (
    <div className={`${mcpClass}`} data-index={index} data-offer-id={offerId} data-rule-expression={props.ruleExpression}>
      <ButtonWithAEM
        {...props}
        text={tokenText}
        icon={tokenIcon}
        iconSrc={iconSrc}
        iconPosition={iconPosition}
        iconAltText={iconAltText}
        anchor={tokenAnchor}
        linkUrl={getButtonURL()}
        linkType={tokenLinkType}
        alignment={tokenAlignment}
        index={index}
        compName={'Button'}
        dataIndex={index}
        dataRuleExpression={props.ruleExpression}
        {...setDispositionProps}
      />
    </div>
  )
}

export default ReactButton
